const getNumberCN = num => {
  const arrDateZH = [
    '零',
    '一',
    '二',
    '三',
    '四',
    '五',
    '六',
    '七',
    '八',
    '九',
    '十'
  ]
  const numStr = `${num}`
  let numList = numStr.split('')
  let arr2 = numList.map(o => arrDateZH[+o])
  if ([10, 11, 12].indexOf(num) !== -1) {
    arr2[0] = arrDateZH[arrDateZH.length - 1]
  }
  return arr2.join('')
}

export const getYcn = timestamp => {
  const currentDate = timestamp ? new Date(timestamp) : new Date()
  const Y = currentDate.getFullYear()
  const M = currentDate.getMonth() + 1
  return `${getNumberCN(Y)}年${getNumberCN(M)}月`
}
